interface Eigenschaften {
  /** Auf dunklem Grund wird die Schrift weiß gesetzt. */
  hell?: boolean
  breite?: number
}

/**
 * Wortmarke „Neoalto Fachlotse" als eingebettetes SVG.
 *
 * <p>Bewusst inline und nicht als &lt;img&gt;: Ein über img geladenes SVG ist ein eigenes Dokument
 * und kommt an die Schriften der Seite nicht heran — der Schriftzug fiele dann auf eine beliebige
 * Serifenschrift zurück. Inline gilt die @font-face-Regel aus global.css.
 */
export default function Wortmarke({ hell, breite = 260 }: Eigenschaften) {
  const schrift = hell ? '#ffffff' : '#121b4c'

  return (
    <svg
      viewBox="0 0 300 96"
      width={breite}
      height={(breite * 96) / 300}
      fill="none"
      role="img"
      aria-label="Neoalto Fachlotse"
    >
      <g transform="translate(4 8) scale(1.6667)">
        <circle cx="24" cy="24" r="20" stroke="#f39200" strokeWidth="1.75" />
        <circle cx="24" cy="24" r="16.5" stroke="#f39200" strokeWidth="0.75" />
        <path
          d="M21 13 H27 V19 H33 V25 H27 V31 H21 V25 H15 V19 H21 Z"
          stroke={schrift}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path d="M20 36 H28" stroke={schrift} strokeWidth="1.75" strokeLinecap="round" />
      </g>

      <text x="100" y="46" className="wortmarke-name" fill={schrift}>
        Neoalto
      </text>
      <line x1="100" y1="58" x2="252" y2="58" stroke="#f39200" strokeWidth="1" />
      <text x="100" y="86" className="wortmarke-zusatz" fill={schrift}>
        Fachlotse
      </text>
    </svg>
  )
}
